import React, { useRef } from 'react'
import GatsbySEO from '@components/sections/seo/seo_v3'
import { IGatsbyImageDataObject, IGatsbyPageProps } from '@et/types/Gatsby'
import { graphql, useStaticQuery } from 'gatsby'
import Layout from '../components/layout'
import { courseKeys, courseModulesV2 } from '../courses/coursesDataList'
import ProcreatePatternsTheme from '@styles/themes/procreatePatternsTheme'
import ClassTrailerLayoutA from '@components/sections/trailers/classTrailerLayoutA'
import IPadLayoutA from '@components/sections/ipadLayouts/iPadLayoutA'
import WhatMakesCourseDiffList from '@components/sections/whatMakesCourseDifferent/whatMakesCourseDiffList'
import WhatYoullLearnV5, { IWYLItem, WYLItemEnums } from '@components/sections/whatYoullLearn/whatYoullLearnV5'
import HeaderQuote from '@components/headers/headerQuote'
import BrushImgStack from '@components/sections/brushLayoutGrid/brushImgStack'
import FullScreenProject, { ProjectPositionEnums } from '@components/projects/fullScreenProject'
import BonuseProjectA from '@components/projects/bonuseProjectA'
import LogoSvgList from '@components/sections/logoLists/logoSvgList'
import InstructorFloralV4 from '@components/sections/instructorLayouts/instructorFloral_V4'
import SelfPacedV4 from '@components/sections/selfPaced_v4'
import CurriculumLayoutB from '@components/sections/curriculumLayoutB'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import BonusesLayoutB from '@components/sections/bonusesLayoutB'
import ReqsHalfPage from '@components/sections/requirements/reqsHalfPage'
import FaqLayoutB from '@components/sections/faqs/faqLayoutB'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import LetsDooThisLayoutB from '@components/sections/letsDooThisLayoutB'
import SellCardLayoutAV3 from '@components/sections/courseCard/sellCardLayoutA_v3'
import { DarkTheme } from '@styles/themes/darkTheme'
import SellCardDouble from '@components/sections/courseCard/sellCardDouble'
import ProcreatePatternsHero from '@components/sections/custom/procreatePatternsHero'
import EmailSignUp1 from '@components/sections/signups/emailSignUp1'
import PatternIntroImages from '@components/sections/custom/patternIntroImages'
import FooterSignup from '@components/sections/signups/footerSignup'
import IntroSignUp from '@components/sections/signups/introSignUp'
import { useScrolledElement } from '@hooks/useScrolledElement'
import PriceBar from '@components/nav/priceBar'
import VideoLayoutB from '@components/sections/trailers/videoLayoutB'
import Section3 from '@components/sections/section3'
import IPadImgV4 from '@components/imageModules/v4/iPadImgV4'
import BonusLayoutC from '@components/sections/custom/bonusLayoutC'
import PatternIntro from '@components/sections/custom/patterns/intro'
import ProcreateIntroPart2 from '@components/sections/custom/patterns/introPart2'
import ProcreateIntroPart3 from '@components/sections/custom/patterns/introPart3'
import PatternsIntroPart4 from '@components/sections/custom/patterns/introPart4'
import PatternsIntroPart5 from '@components/sections/custom/patterns/introPart5'
import HeaderQuoteB from '@components/headers/headerQuoteB'
import SubSection from '@components/headers/subSection'
import PatternBonus1 from '@components/sections/custom/patterns/patternBonus1'
import PatternBonus2 from '@components/sections/custom/patterns/patternBonus2'
import PatternBonus3 from '@components/sections/custom/patterns/patternBonus3'
import PatternBonus4 from '@components/sections/custom/patterns/patternBonus4'
import WorkingBtn from '@components/buttons/workingBtn'
import PatternClassCard from '@components/sections/custom/patterns/patternClassCard'
import Pattern30Day from '@components/sections/custom/patterns/pattern30Day'
import PatternBrushes from '@components/sections/custom/patterns/patternBrushes/patternBrushes'
import PatternLetsDoThis from '@components/sections/custom/patterns/patternLetsDoThis'
import PatternAbout from '@components/sections/custom/patterns/patternAbout'
import PatternBrushStacked from '@components/sections/custom/patterns/patternBrushes/patternBrushStacked'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { JsonLdCourse, JsonLdFaqString } from '@utils/jsonLdUtils'
import { classNames } from '@utils/genUtils'
import LfmTestimonial from '@components/sections/testimonails/testimonial'
import { Testimonial } from '@et/types/Courses'
import FacebookTestimonial from '@components/sections/testimonails/facebookTestimonial'
import CourseDiffItem from '@components/sections/whatMakesCourseDifferent/courseDiffItem'

const ProcreatePatterns = (props: IGatsbyPageProps) => {
  const { patternHero, breakOpenIpad, WMCD1, WMCD2, WMCD3, WMCD4, WMCD5, WMCD6, WMCD7, WMCD8, WMCD9, WMCD10, WMCD11, WMCD12, wylTall, wylGridImage1, wylGridImage2, wylGridImage3, wylGridImage4, wylGridImage5, wylGridImage6, wylGridImage7, wylGridImage8, wylGridImage9, wylGridImage10, wylGridImage11, wylGridImage12, wylSquareImage1, wylSquareImage2, patternIntro_1, patternIntro_2, titleArt, intro3, intro4, gif1, bonusModule3_1, finalWallpaper, bonusHero1, bonus2_1, bonus2_2, bonus2_3, introImage, preview1, preview2, preview4, breakOut, bonus2Bg, playgroundVideo, playgroundPoster, reqsFeaturedImage, teelaWorking2, project1, project2, project3, project4, project5, teelaWorking, brushTip1, brushTip2, brushTip3, brushTip4, brushTip5, brushTip6, brushTip7, brushTip8, brushTip9, brushTip10, brushTip11, brushTip12, pattern_1, brushTip2_1, brushTip2_2, brushTip2_3, brushTip2_4, brushTip2_5, brushTip2_6, brushTip2_7, brushTip2_8, moneyBack, author1, aboutIpad, bonusModule4, ipadFlatLight, flatFloralsHero, ipadHero, heroArt, outlineHeroArt, heroPencil, videoflower, hearts_V3, iPadTop, learnHeader, project1Bg, project1A, project1B, project1C, project2A, project2B, project2Bg, project3Bg, project3A, project3B, project4A, project4Bg, project5Bg, project6Bg, project6A, project6B, project6C, project6D, projectBonusA, projectBonusB, projectBonusC, profileFlower, faqFlower, dividerImg1, dividerImg2, dividerImg3, dividerImg4, dividerImg5, dividerImg6, profileImg, selfPacedImg, letsDoThisImg, sellCardImg, paymentPlanImage, brushStack0, brushStack2, brushStack3, brushStack4, aliTestimonialProfile, aliTestimonialArt, debMTestimonialProfile, debMTestimonialArt, lisaMarieTestimonialProfile, lisaMarieTestimonialArt, heatherTTestimonialProfile, heatherTTestimonialArt, hayleyDTestimonialArt, hayleyDTestimonialProfile, jenniMTestimonialArt, jenniMTestimonialProfile, fbTestimonial10, fbTestimonial09, fbTestimonial08, fbTestimonial07, fbTestimonial06, fbTestimonial05, fbTestimonial04, fbTestimonial03, fbTestimonial02, fbTestimonial01
  } = useStaticQuery(

    graphql`
        query {
            patternHero: imgixImage(url: "procreate-patterns/procreate-patterns-hero.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 2800)
            },
            breakOpenIpad: imgixImage(url: "procreate601/class-projects.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w:1200
                    fit: "fill"
                })
            }
            wylTall: imgixImage(url: "procreate-patterns/wyl/wyl-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 500
                })
            }
            bonus2Bg: imgixImage(url: "procreate-patterns/bonuse2-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            playgroundVideo: file(relativePath: { eq: "procreate-patterns/pattern-playground-teaser-low-res.mp4"}) {
                publicURL
            }
            playgroundPoster: imgixImage(url: "procreate-patterns/video-static.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    auto: "compress",
                })
            }
            reqsFeaturedImage: imgixImage(url: "procreate-patterns/Multiple-Fabric-Swatches-Mockup-pre-reqs-section.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            }
            beautifulLetteringImg: imgixImage(url: "procreate-patterns/beautiful-lettering-header-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            titleArt: imgixImage(url: "procreate-patterns/iPad-title-art.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            introImage: imgixImage(url: "procreate-patterns/rolls-and-ipad-wait-page-mock.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            preview1: imgixImage(url: "procreate-patterns/preview-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            preview2: imgixImage(url: "procreate-patterns/preview-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            preview4: imgixImage(url: "procreate-patterns/preview-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            breakOut: imgixImage(url: "procreate-patterns/break-out-the-ipad.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1200)
            },
            ipadFlatLight: imgixImage(url: "ipad-device-flat-light.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1200
                })
            }
            patternProj1: imgixImage(url: "procreate-patterns/proj1-fabric-ipad.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            playgroundBg: imgixImage(url: "procreate-patterns/playground-bg-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonusHero1: imgixImage(url: "procreate-patterns/bonus-1-hero.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonus2_1: imgixImage(url: "procreate-patterns/bonus-2-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonus2_2: imgixImage(url: "procreate-patterns/bonus-2-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonus2_3: imgixImage(url: "procreate-patterns/bonus-2-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            patternIntro_1: imgixImage(url: "procreate-patterns/pattern-intro-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            patternIntro_2: imgixImage(url: "procreate-patterns/pattern-intro-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            titleCardImg: imgixImage(url: "procreate-patterns/title-card-logo-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project1: imgixImage(url: "procreate-patterns/project1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project2: imgixImage(url: "procreate-patterns/project2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project3: imgixImage(url: "procreate-patterns/project3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project4: imgixImage(url: "procreate-patterns/project4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project5: imgixImage(url: "procreate-patterns/project5.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            teelaWorking: imgixImage(url: "procreate-patterns/teela-working-on-ipad.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            teelaWorking2: imgixImage(url: "procreate-patterns/teela-working-on-ipad2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            pattern_1: imgixImage(url: "procreate-patterns/procreate-pattern-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            moneyBack: imgixImage(url: "procreate-patterns/30-day-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            author1: imgixImage(url: "procreate-patterns/about-section-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            aboutIpad: imgixImage(url: "procreate-patterns/about-section-ipad-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            finalWallpaper: imgixImage(url: "procreate-patterns/final-wallpaper-wall.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonusModule4: imgixImage(url: "procreate-patterns/bonus-module-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            selfPacedImg: imgixImage(url: "procreate-patterns/self-paced-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            bonusModule3_1: imgixImage(url: "procreate-patterns/bonus-module-3-1-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }









            hearts_V3: imgixImage(url: "procreate401/hearts.png") {
              gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
              })
            }
            learnHeader: imgixImage(url: "procreate701/wyl/wyl-vertical.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 500
                })
            }
            flatFloralsHero: imgixImage(url: "procreate701/site-header-72.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            courseCardImg: imgixImage(url: "procreate601/class-card-small.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            ipadHero: imgixImage(url: "device-3-v-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            heroArt: imgixImage(url: "procreate701/ff-hero-flowers-min.png") {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            outlineHeroArt: imgixImage(url: "procreate701/ff-hero-outline.jpg") {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            heroPencil: imgixImage(url: "apple-pencil-flat-min.png") {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            videoflower: imgixImage(url: "procreate701/ff-project_1C-flower-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project1Bg: imgixImage(url: "procreate701/project-1/project-1-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project1A: imgixImage(url: "procreate701/project-1/project-1-a.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project1B: imgixImage(url: "procreate701/project-1/project-1-b.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project1C: imgixImage(url: "procreate701/project-1/project-1-c.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project2Bg: imgixImage(url: "procreate701/project-2/project-2-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project2A: imgixImage(url: "procreate701/project-2/project-2-a.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {}, srcSetMaxWidth: 1200)
            }
            project2B: imgixImage(url: "procreate701/project-2/project-2-b.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project3A: imgixImage(url: "procreate701/project-3/project-3-a.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project3B: imgixImage(url: "procreate701/project-3/project-3-b.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project3Bg: imgixImage(url: "procreate701/project-3/project-3-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project4A: imgixImage(url: "procreate701/project-4/project-4-a.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project4Bg: imgixImage(url: "procreate701/project-4/project-4-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project5Bg: imgixImage(url: "procreate701/project-5/project-5-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {},srcSetMaxWidth: 1200)
            }
            project6Bg: imgixImage(url: "procreate701/project-6/env-pattern.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project6A: imgixImage(url: "procreate701/project-6/project-6-1-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project6B: imgixImage(url: "procreate701/project-6/project-6-2-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project6C: imgixImage(url: "procreate701/project-6/project-6-3-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            project6D: imgixImage(url: "procreate701/project-6/pattern-colors.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            projectBonusA: imgixImage(url: "procreate701/project-bonus/bonus-project-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {

                },srcSetMaxWidth: 800)
            }
            projectBonusB: imgixImage(url: "procreate701/project-bonus/bonus-project-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            projectBonusC: imgixImage(url: "procreate701/project-bonus/bonus-project-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            profileFlower: imgixImage(url: "procreate701/author-flower-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            faqFlower: imgixImage(url: "procreate701/faq-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            brushStack0: imgixImage(url: "procreate701/brushes/brush-stack-0.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1111)
            }
            brushStack2: imgixImage(url: "procreate701/brushes/brush-stack-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1111)
            }
            brushStack3: imgixImage(url: "procreate701/brushes/brush-stack-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1111)
            }
            brushStack4: imgixImage(url: "procreate701/brushes/brush-stack-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                  fit: "crop",
                  auto: "compress"
              }, srcSetMaxWidth: 1111)
            }
            iPadTop: imgixImage(url: "procreate701/ipad-adv2-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            letsDoThisImg: imgixImage(url: "procreate701/lets-do-this-min.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            profileImg: imgixImage(url: "author-profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            sellCardImg: imgixImage(url: "procreate701/sell-card.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            paymentPlanImage: imgixImage(url: "procreate701/paymentplan-card.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg1: imgixImage(url: "procreate701/env-1.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg2: imgixImage(url: "procreate701/env-2.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg3: imgixImage(url: "procreate701/env-3.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg4: imgixImage(url: "procreate701/env-4-alt.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg5: imgixImage(url: "procreate701/env-5.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            dividerImg6: imgixImage(url: "procreate701/env-6.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            intro3: imgixImage(url: "procreate-patterns/intro-3-bg.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                }, srcSetMaxWidth: 1600)
            }
            intro4: imgixImage(url: "procreate-patterns/introbg-4.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                })
            }
            gif1: imgixImage(url: "procreate-patterns/magnetic-snapping.gif") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            aliTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/ali_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            aliTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/ali-art-web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            debMTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/deb_m_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            debMTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/deb_m_web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            lisaMarieTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/lisa_marie_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            lisaMarieTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/lisa_marie_web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            heatherTTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/heather_t_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            heatherTTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/heather_t_web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            hayleyDTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/hayley_d_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            hayleyDTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/hayley_d_web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            jenniMTestimonialProfile: imgixImage(url: "procreate-patterns/testimonials/jenni_m_profile.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            jenniMTestimonialArt: imgixImage(url: "procreate-patterns/testimonials/jenni_m_web.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial01: imgixImage(url: "procreate-patterns/testimonials/facebook/01.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial02: imgixImage(url: "procreate-patterns/testimonials/facebook/02.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial03: imgixImage(url: "procreate-patterns/testimonials/facebook/03.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial04: imgixImage(url: "procreate-patterns/testimonials/facebook/04.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial05: imgixImage(url: "procreate-patterns/testimonials/facebook/05.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial06: imgixImage(url: "procreate-patterns/testimonials/facebook/06.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial07: imgixImage(url: "procreate-patterns/testimonials/facebook/07.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial08: imgixImage(url: "procreate-patterns/testimonials/facebook/08.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial09: imgixImage(url: "procreate-patterns/testimonials/facebook/09.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            fbTestimonial10: imgixImage(url: "procreate-patterns/testimonials/facebook/10.jpg") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
            
            ...FragmentProcreatePatternsWMCD_Images
            ...FragmentProcreatePatternsWYL
            ...FragmentProcreatePatternsBrushTips
        }
    `)

  const brushData = [
    {
      img: 'procreate-patterns/brushes/brush-1-1-min.png',
      name: 'Solid Ink',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-2-min.png',
      name: 'Peculiar Ink',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-3-min.png',
      name: 'Ink Blobber',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-4-min.png',
      name: 'Watery Ink Wash',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-5-min.png',
      name: 'Inky Wash',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-6-min.png',
      name: 'Sticky Ink',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-7-min.png',
      name: 'Dying Marker',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-8-min.png',
      name: 'Simple Scratch',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-9-min.png',
      name: 'Broken Ink',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-10-min.png',
      name: 'Messy Thick Ink',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-11-min.png',
      name: 'Little Dots',
    },
    {
      img: 'procreate-patterns/brushes/brush-1-12-min.png',
      name: 'Scratchy Dots',
    },
  ]
  const brushTips = [
    brushTip1,
    brushTip2,
    brushTip3,
    brushTip4,
    brushTip5,
    brushTip6,
    brushTip7,
    brushTip8,
    brushTip9,
    brushTip10,
    brushTip11,
    brushTip12,
  ]
  const brushTipSet2 = [
    brushTip2_1,
    brushTip2_2,
    brushTip2_3,
    brushTip2_4,
    brushTip2_5,
    brushTip2_6,
    brushTip2_7,
    brushTip2_8,
  ]
  const brushDataSet2 = [
    {
      img: 'procreate-patterns/brushes/brush-2-1-jpg',
      name: 'Diamond',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-2-jpg',
      name: 'Ogee',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-3-jpg',
      name: 'Seashell',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-4-jpg',
      name: 'Star',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-5-jpg',
      name: 'Flower',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-6-jpg',
      name: 'Circles',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-7-jpg',
      name: 'Vertical Stripe',
    },
    {
      img: 'procreate-patterns/brushes/brush-2-8-jpg',
      name: 'Horizontal Stripe',
    },
  ]
  const courseDifferentiators = [
    {
      title: 'Process Perfect',
      description: 'Non-destructive files and easy to follow',
      image: WMCD1
    },
    {
      title: 'Template Canvases',
      description: 'With pre-programmed selections, say goodbye to pesky hairlines forever!',
      image: WMCD2
    },
    {
      title: '15 Composition Templates',
      description: 'No artist block here! Flexible templates that give you a perfect pattern roadmap for gorgeous patterns',
      image: WMCD3
    },
    {
      title: 'Pattern Playground',
      description: 'An online tool for previewing, testing, rescaling, recoloring *and* saving your repeat patterns',
      image: WMCD4
    },
    {
      title: 'Flower + Foliage Drawing Tutorials',
      description: 'So you can learn pattern making without the stress of what to put in them',
      image: WMCD5
    },
    {
      title: 'Mock up your Artwork',
      description: 'Preview your patterns on products following a simple Procreate mock up process',
      image: WMCD6
    },
    {
      title: 'Exporting + Printing',
      description: 'Export your pattern square in the proper file type + let the fabric and wallpaper magic begin!',
      image: WMCD7
    },
    {
      title: 'Ai Swatches + .PAT files',
      description: 'Learn how to convert your Procreate patterns into Illustrator swatch files and Photoshop pattern files',
      image: WMCD8
    },
    {
      title: 'Everything you Need',
      description: 'Beginner-friendly, step-by-step tutorials with all the brushes, colors, templates + resources included. Enrollment = lifetime access',
      image: WMCD9
    }
  ]
  const wylItems: IWYLItem[] = [
    {
      title: 'Full Drop Patterns',
      desc: 'Master the grid-like repeat',
      bg: {
        image: wylGridImage1,
        classes: 'bg-cream-200'
      },
    },
    {
      title: 'Half Drop Patterns',
      desc: 'Drop those columns by half and make it all make sense',
      bg: {
        image: wylGridImage2,
        classes: 'bg-cream-300'
      },
    },
    {
      title: 'Half Brick Patterns',
      desc: 'Offset those rows and see magic alignment unfold',
      bg: {
        image: wylGridImage3,
        classes: 'bg-[#b5bc9b]'
      },
    },
    {
      title: 'Block Style Patterns',
      desc: "Block party with your basic 'think inside the box' mentality",
      className: 'text-white',
      bg: {
        image: wylGridImage4,
        classes: 'bg-[#452324]'
      },
    },
    {
      title: 'Symmetry Block Patterns',
      desc: 'Still at the block party, but make shapes the guest of honor',
      bg: {
        image: wylGridImage5,
        classes: 'bg-[#f0dad0]'
      },
    },
    {
      title: 'Toss Patterns',
      desc: 'Throw the confetti! Scatter those elements, but make em all seamless + perfect',
      bg: {
        image: wylGridImage6,
        classes: 'bg-cream-200'
      },
    },
    {
      title: 'Easy Florals + Foliage',
      desc: 'Drawing tutorials so you\'ll have artwork ready for your future patterns',
      bg: {
        image: wylGridImage7,
        classes: 'bg-cream-300'
      },
    },
    {
      title: 'Pattern Playground',
      desc: 'Get ready to test your patterns in the quickest, easiest + most fun way ever',
      bg: {
        image: wylGridImage8,
        classes: 'bg-[#b5bc9b]'
      },
    },
    {
      title: 'Multiple Colorways',
      desc: 'Use 2 gestures to create multiple pattern colorways in a snap',
      className: 'text-white',
      bg: {
        image: wylGridImage9,
        classes: 'bg-[#cc9226]'
      },
    },
    {
      title: 'Procreate Mockups',
      desc: 'Preview your patterns on real items using 2 different Procreate methods',
      bg: {
        image: wylGridImage10,
        classes: 'bg-cream-200'
      },
    },
    {
      title: 'Exporting + Printing',
      desc: 'See your patterns come to life on fabric and wallpaper (+ my recs!)',
      bg: {
        image: wylGridImage11,
        classes: 'bg-cream-300'
      },
    },
    {
      title: 'Ai Swatches + .PAT files',
      desc: 'Convert your patterns into rasterized illustrator swatches + Photoshop pattern files',
      bg: {
        image: wylGridImage12,
        classes: 'bg-[#b5bc9b]'
      },
    },
    {
      title: '',
      desc: '',
      imageOnly: {
        image: wylSquareImage1,
        type: WYLItemEnums.TYPE1
      },
    },
    {
      title: '',
      desc: '',
      imageOnly: {
        image: wylSquareImage2,
        type: WYLItemEnums.TYPE2
      },
    },
  ]
  const wylSquareImages = [
    wylSquareImage1,
    wylSquareImage2,
  ]
  const project1Images = [
    project1A,
    project1B,
    project1C,
  ]
  const project2Images = [
    project2A,
    project2B,
  ]
  const project3Images = [
    project3A,
    project3B,
  ]
  const project6Images = [
    project6A,
    project6B,
    project6C,
  ]
  const projectBonusImages = [
    projectBonusA,
    projectBonusB,
    projectBonusC,
  ]
  const brushImages = [
    brushStack0,
    brushStack2,
    brushStack3,
    brushStack4
  ]

  const patternsIntro = [
    {
      alt: 'Florals repeat patterns cloth roll',
      image: preview1
    },
    {
      alt: '4 Printed floral patterns',
      image: preview2
    },
    {
      alt: 'Floral pattern on a swatch card',
      image: preview4
    }
  ]

  const course = courseModulesV2[courseKeys.ProcreatePatterns]

  const referenceSectionRef = useRef(null);
  const priceRef = useRef(null);
  const { hasScrolled, hasScrolledPrice } = useScrolledElement(referenceSectionRef, priceRef)
  const courseJsonLd = JsonLdCourse({
    name: 'Floral Patterns in Procreate',
    url: 'https://learn.every-tuesday.com/procreate-patterns',
    headline: 'Learn how to create floral patterns in procreate',
    description: 'Create beautiful patterns directly in Procreate!',
    audience: "Surface Designers",
    text: "Floral Patterns in Procreate, the ultimate pattern making process. Create beautifully seamless, repeat patterns in Procreate every single time.",
    price: "197.00",
    paymentPlanPrice: "75.00",
    timeRequired: "PT4H45M",
    image: [
      "https://etheadless.local/wp-content/uploads/2021/02/wrapped-flower-bouquet-procreate-social-1440x810.jpg",
      "https://etheadless.local/wp-content/uploads/2021/05/wrapped-flower-bouquet-procreate-pinterest.jpg"
    ]
  })

  const testimonialOne: Testimonial = {
    backgroundColor: 'bg-[#f5f5f5]',
    name: {
      first: 'Ali',
      last: 'S.'
    },
    profileImg: aliTestimonialProfile,
    instagramHandle: 'koukadesigns_alisale',
    featuredImage: aliTestimonialArt,
    pullQuote: 'Thanks so much for the amazing pattern making course!',
    quote: 'Not only did this cover so much about repeat patterns, but it included some fantastic supporting information about Spoonflower and other very useful hints and tips. And huge congratulations on the Pattern Playground … such an awesome tool that you and Spence put together for us all!',
    url: 'https://www.instagram.com/koukadesigns_alisale',
  }

  const testimonialTwo: Testimonial = {
    backgroundColor: 'bg-cream-300',
    name: {
      first: 'Deb',
      last: 'M.'
    },
    profileImg: debMTestimonialProfile,
    instagramHandle: 'debminerdesigner',
    featuredImage: debMTestimonialArt,
    pullQuote: 'This class was a great value—the bonus modules alone were worth the price.',
    quote: 'Even though I’ve been designing repeating patterns for several years, when Teela released Floral Patterns in Procreate, I signed up right away—because even though I know many ways to create patterns, I knew she would include workflows or ways of doing things that I would benefit from. Teela is such a generous and knowledgeable teacher!',
    url: 'https://www.instagram.com/debminerdesigner/',
  }

  const testimonialThree: Testimonial = {
    backgroundColor: 'bg-[#fff2d6]',
    name: {
      first: 'Lisa Marie',
      last: 'B.'
    },
    profileImg: lisaMarieTestimonialProfile,
    instagramHandle: 'abundant.sunshine',
    featuredImage: lisaMarieTestimonialArt,
    pullQuote: 'The detail she has put into this course is outstanding.',
    quote: 'I knew the course would be great, since Teela was teaching it, but I am amazed! I’ve taken several pattern courses on Skillshare, and they can’t hold a candle to this course. And the best part…no hairlines! For almost all the other courses I took, within the first pattern or two I would have a hairline with no feedback on how to fix it. Can’t wait to spend my Sunday working on more modules!',
    url: 'https://www.instagram.com/abundant.sunshine/',
  }

  const testimonialFour: Testimonial = {
    backgroundColor: 'bg-[#e1e5e1]',
    name: {
      first: 'Heather',
      last: 'T.'
    },
    profileImg: heatherTTestimonialProfile,
    instagramHandle: 'designbyheathert',
    featuredImage: heatherTTestimonialArt,
    pullQuote: 'So much knowledge and so many goodies!',
    quote: 'SO FUN! I signed up for Teela’s Floral Patterns in Procreate, and as usual with her classes, I am over the moon. So much knowledge and so many goodies!',
    url: 'https://www.instagram.com/designbyheathert/',
  }
  const testimonialFive: Testimonial = {
    backgroundColor: 'bg-[#f5f5f5]',
    name: {
      first: 'Hayley',
      last: ''
    },
    profileImg: hayleyDTestimonialProfile,
    instagramHandle: 'hayleydesignsx',
    featuredImage: hayleyDTestimonialArt,
    pullQuote: 'Every class I take, I think it’s my new favorite but then I realize I just love all of Teela’s courses!',
    quote: 'As a teacher myself, I’m a HUGE fan of how Teela models and explains everything as she does it. If you’re contemplating buying any of the courses - do it. It’s so, so worth it.',
    url: 'https://www.instagram.com/hayleydesignsx/',
  }
  const testimonialSix: Testimonial = {
    backgroundColor: 'bg-cream-300',
    name: {
      first: 'Jenni',
      last: 'M.'
    },
    profileImg: jenniMTestimonialProfile,
    featuredImage: jenniMTestimonialArt,
    pullQuote: 'A must-take for pattern makers if you are at all interested in using Procreate to make patterns!',
    quote: 'I completed Immersion this year so I\'ve been making patterns in Illustrator a lot and it is great, but I am most familiar with Procreate and I was struggling to find a way to mesh my style with the Illustrator workflow.As soon as I saw this course I knew I had to take it and I am so glad I did.I\'m now creating my 2nd collection, all in Procreate with the knowledge that I learned in this course and the best part is that it\'s all in my style, no compromising for Illustrator / vectorization!',
    url: 'https://www.tinyleafpress.com/',
  }
  const facebookImages = [
    fbTestimonial10, fbTestimonial09, fbTestimonial08, fbTestimonial07, fbTestimonial06, fbTestimonial05, fbTestimonial04, fbTestimonial03, fbTestimonial02, fbTestimonial01
  ]
  return (
    <Layout path={props.location.pathname} theme={ProcreatePatternsTheme} stickyNav={false} >
      <GatsbySEO
        sentinel={true}
        proof={false}
        course={course}
        classCard={'https://et-teachable.imgix.net/procreate-patterns/procreate-patterns-class-card.jpg'}>
        <link rel='preconnect' href='https://fonts.gstatic.com' />
        <link
          href='https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500&display=swap'
          rel='stylesheet' />
        <script type="application/ld+json">{JSON.stringify(courseJsonLd)}</script>
        <script type="application/ld+json">{JsonLdFaqString(course.faqs)}</script>
      </GatsbySEO>

      {/* INSERT HEADER */}
      {/* <WorkingBtn /> */}

      <ProcreatePatternsHero screen={titleArt} backgroundImage={patternHero} />

      <PatternIntro image1={patternIntro_1} image2={gif1} />

      <ProcreateIntroPart2 image={patternIntro_2} />

      <ProcreateIntroPart3 image={intro3} />

      <PatternsIntroPart4 image={intro4} />

      <PatternsIntroPart5 image={teelaWorking} />

      {/* SEAMLESS PATTERN */}
      <div className='w-full px-4 py-8 text-center text-white bg-rusted-900 xl:py-16'>
        <h2 className='relative flex flex-col text-[2.9rem] leading-[2.8rem] font-sentinel__SemiBoldItal md:section-h2 z-3 md:max-w-[480px] mx-auto xl:max-w-none'>
          seamless process = seamless patterns
        </h2>
      </div>

      {/* Sign up Header */}
      {/* <div className='relative overflow-hidden bg-[#F9daca] md:overflow-visible z-2'>
        <IntroSignUp image={introImage} motionMail={course.motionMail} />
      </div> */}

      {/* VIDEO INTRO */}
      {/* <div className='relative overflow-hidden bg-cream-100 md:overflow-visible z-2 lg:pb-12'>
        <ClassTrailerLayoutA
          scrollId='checkout-card'
          containerClasses='bg-cream-100'
          textClasses='text-[#CE8460]'
          videoId={course.videoId}
          btnClasses='btn-ff-teal-600'
          content={{
            header: 'Simplifying with Ease',
            text: 'Create stunning, simplified florals in a variety of flat styles.'
          }}
        />
      </div> */}

      {/* LETS MAKE SOME BEAUTIFUL PATTERNS */}
      {/* <div className='relative pt-10 bg-cream-100 z-3 md:pt-20 md:pb-10 lg:pt-20 lg:pb-20'>
        <PatternIntroImages
          headerImage={beautifulLetteringImg}
          gallery={patternsIntro}
        />
      </div> */}

      {/* IPAD BREAKOUT HEADER */}
      <div className='relative overflow-hidden bg-cream-300 z-3 et-grid-basic md:py-28 lg:pt-48'>
        <div className='col-span-full'>
          <IPadLayoutA
            screen={{
              img: breakOut,
              alt: 'alt'
            }}
            content={{
              header: 'Break out the iPad, it’s time to make patterns.',
              text: `<p>Keep the art supplies in the desk and leave that desktop where it belongs. Take pattern making with you anywhere you go directly in Procreate. With a non-destructive workflow (yay, editable layers!) and 15 composition templates to choose from, you’ll never be wondering what to make or how to get started. </p><p>Reduce your pattern making time and increase your output with a streamlined, step-by-step process than anyone can follow.</p>`,
            }}
          />
        </div>
      </div>

      {/* WHAT MAKE THIS COURSE DIFFERENT */}
      <div className='relative bg-cream-100 z-2 et-grid-basic pt-14 md:pt-28 lg:pt-28'>
        <WhatMakesCourseDiffList
          ItemComponent={CourseDiffItem}
          items={courseDifferentiators} />
      </div>

      {/* FOOTER SIGNUP */}
      {/* <div className='pt-16 bg-cream-100 md:pt-20'>
        <FooterSignup convertKitFormId={'5033823'} />
      </div> */}

      {/* BRUSHES */}
      <div ref={referenceSectionRef} id="start-price" className='py-8 pt-0 et-grid-basic md:pb-16 lg:pt-16 bg-cream-100'>
        <div className='col-span-2 col-start-2 mt-8 mb-16 text-center lg:mb-0 md:col-start-2 md:col-span-12'>

          <HeaderQuoteB content={brushContent} />
          <SubSection
            textClassNames='text-left text-lg xl:flex-[1_0_50%]'
            innerClassNames='xl:max-w-[1000px]'
            content={brushContent}
            textContent={<BrushesText />}
            altContent={<ExtendedLicenseInfo image={pattern_1} />}
          />
        </div>

        <div className='col-span-2 col-start-2 mb-8 text-center border-t-4 border-grey-600 md:col-start-2 md:col-span-12 lg:max-w-[900px] lg:mx-auto xl:max-w-[1200px]' >
          <SubSection
            textClassNames='text-left text-lg md:pl-0 md:pr-4 xl:pr-44 xxl:pr-52'
            innerClassNames='mt-8 !col-span-full md:max-w-none md:!items-start xl:mt-12 !mb-0 xl:!items-start xxl:max-w-none'
            content={brushContent}
            textContent={<BrushesText1 />}
            altContent={<BrushesDesc1 />}
          />
        </div>

        {/* INSERT BRUSH IMAGE 1 */}
        <div className='col-span-full'>
          <PatternBrushes brushData={brushData} brushImages={brushTips} />
        </div>

        <div className='flex flex-col col-span-2 col-start-2 mt-16 mb-8 text-center border-t-4 border-grey-600 md:col-start-2 md:col-span-12 md:mb-4 lg:max-w-[900px] lg:mx-auto xl:max-w-[1200px] xl:mt-28' >
          <SubSection
            textClassNames='text-left text-lg md:pl-0 md:pr-4 xl:pr-44 xxl:pr-52'
            innerClassNames='mt-8 !col-span-full md:max-w-none md:!items-start xl:mt-12 !mb-0 xl:!items-start xxl:max-w-none'
            content={brushContent}
            textContent={<BrushesText2 />}
            altContent={<BrushesDesc2 />}
          />
        </div>

        {/* INSERT BRUSH IMAGE 2 */}
        <div className='col-span-full'>
          <PatternBrushStacked brushData={brushDataSet2} brushImages={brushTipSet2} />
        </div>
      </div>

      {/* WHAT YOU'LL LEARN */}
      <div className='relative bg-cream-100'>
        <WhatYoullLearnV5
          title='What you’ll learn in this course'
          subTitle='BUILD YOUR SKILLS'
          subTitleClasses='text-[#CE8460]'
          titleImage={wylTall}
          items={wylItems}
        />
      </div>

      {/* PATTERN PLAYGROUND */}
      <div className='relative overflow-hidden bg-cream-100 md:overflow-visible z-2'>
        <VideoLayoutB
          textClasses='text-[#CE8460]'
          mp4={{
            posterSrc: playgroundPoster,
            src: playgroundVideo.publicURL
          }}
          btnClasses='btn-ff-teal-600'

          content={{
            buttonText: 'I\'m ready!',
            header: 'Testing patterns within Procreate has officially come to an end 🎉',
            text: 'Creating multiple layer copies for testing is done-zo. Rescaling manually and aligning anxious edges is gone for good. The torture of this insane process is over, you guys.'
          }}
          children={<>
            <h3 className='mb-2 text-2xl font-sentinel__SemiBoldItal md:text-3xl'>
              Introducing: the Pattern Playground
            </h3>
            <p className='mb-4 text-lg'>
              Test faster, find where you need to edit quicker + experiment with scale <span className='italic font-bold'>and</span> color. Annnd you can <span className='font-bold'>save out your repeats</span>, too! ✨
            </p>
            <p className='mb-12 text-lg'>
              Life changing? It might be.
            </p>
          </>}
        />
      </div>

      <div className='py-20 lg:py-40'>
        <LfmTestimonial direction='left' testimonial={testimonialThree} />
      </div>

      <div className='pb-20 lg:pb-40'>
        <LfmTestimonial

          direction='right'
          testimonial={testimonialTwo} />
      </div>

      {/* CLASS PROJECTS HEADER */}
      <div className='py-12 et-grid-basic gap-y-0 lg:gap-y-0 lg:pb-20 xl:pb-28 bg-cream-100'>

        <div className='hidden md:block md:col-start-1 md:col-span-5 md:row-start-1 md:row-span-2 xl:col-start-2 xl:col-span-4'>
          <LazyLoadImage
            alt={
              'Pattern Bonus 3: Spoonflower wallpaper application'
            }
            className='relative w-full z-2'
            height={436}
            visibleByDefault={false}
            src={'https://et-teachable.imgix.net/procreate-patterns/class-projects.gif'} // use normal <img> attributes as props
            width={350} />
        </div>

        <div className='row-start-1 col-span-2 col-start-2 md:mx-[-40px] md:col-start-7 md:col-span-6 md:pt-8 lg:pt-16'>
          <h2 className='text-5xl font-sentinel__SemiBoldItal text-grey-800 lg:mt-4 lg:text-6xl xxl:text-7xl'>Class projects</h2>
          <h3 className='mt-2 text-2xl'>Let's make awesome things while learning awesome things</h3>
        </div>

        <div className='row-start-2 col-span-2 col-start-2 md:mx-[-40px] md:col-start-7 md:col-span-6 md:pb-8 lg:pb-16'>
          <h2 className='mt-8 text-2xl font-sentinel__SemiBoldItal lg:text-4xl lg:mb-4'>Create 5 pattern projects using 4 different pattern making methods</h2>
          <p className='text-lg'>Everything you need to create each project is included, along with full step-by-step video instruction.</p>
        </div>

      </div>

      {/* PROJECT 1 */}
      <FullScreenProject project={{
        subTitle: 'Seashell Symmetry',
        title: 'Project 1',
        desc: '<p>We kick things off with a seashell symmetry full drop pattern. We\'ll set up our template together using the symmetry block brushes, paint in the elements, then make all edges seamless through pre-programmed selections. Once we have all of our gaps filled in, we\'ll drag it into the Pattern Playground for a final test.</p>',
        image: project1,
      }} />

      {/* PROJECT 2 */}
      <FullScreenProject project={{
        subTitle: 'Full Drop Flower',
        title: 'Project 2',
        desc: '<p>To reinforce what we covered in Project 1, we\'ll use another symmetry block brush - this time the flower shape, and create another full drop pattern. I share how I fix troublesome areas when elements moving in different directions collide and I explain my full thought process along with my reasons behind every decision I make. We reconfigure our pattern to make it seamless using our pre-programmed selections and do a final test using the Pattern Playground.</p>',
        image: project2,
        position: ProjectPositionEnums.RIGHT,
        bgPosition: ProjectPositionEnums.RIGHT,
      }} />

      {/* PROJECT 3 */}
      <FullScreenProject project={{
        subTitle: 'Full Drop Composition',
        title: 'Project 3',
        desc: '<p>In Project 3, we create a full drop repeat using an included composition template. Following the composition template, we\'re able to speed up our workflow and quickly adjust and adapt it to fit our needs. Once our elements are in place, we use our pre-programmed selections within the template to fill in the gaps, then test + adjust as needed using the Pattern Playground.</p>',
        image: project3,
      }} />

      {/* PROJECT 4 */}
      <FullScreenProject project={{
        subTitle: 'Half Drop Composition',
        title: 'Project 4',
        desc: '<p>It\'s time to head into half drop patterns in Project 4! We\'ll work with a different composition template this time, pre-programmed with selections and set up specifically for half drops. After painting our elements in, we\'ll reorganize the template to fill in gaps using our selections, then test + adjust using the Pattern Playground.</p>',
        image: project4,
        position: ProjectPositionEnums.RIGHT,
        bgPosition: ProjectPositionEnums.RIGHT,
      }} />

      {/* PROJECT 5 */}
      <FullScreenProject project={{
        title: 'Project 5',
        subTitle: 'Half Brick Composition',
        desc: '<p>To round out our pattern types, Project 5 is all about the half brick. We\'ll pick a half brick specific composition template, lay in our artwork and go off script from the template as needed. We then reorganize our artwork using the pre-programmed selections to fill in gaps and test our completed half brick within the Pattern Playground.</p>',
        image: project5,
      }} />

      <PatternBonus1 image={bonusHero1} />

      <PatternBonus2 images={[
        { src: bonus2_1, alt: 'Bonus Module 2: T-Shirt Design' },
        { src: bonus2_2, alt: 'Bonus Module 2: Tote Bag Mock-up' },
        { src: bonus2_3, alt: 'Bonus Module 2: Notebook Mock-up' }
      ]} />

      <PatternBonus3 image={bonusModule3_1} image2={finalWallpaper} />

      <PatternBonus4 image={bonusModule4} />

      <div className='pt-24'>
        <SelfPacedV4
          customScrollId='checkout-card'
          buttonCssClass={'et-btn bg-[var(--pattern-orange)] text-white !normal-case'}
          imgAlt={'Watercolor florals in Procreate is 100% self-paced learning'}
          content={selfPaced}
          {...course}
          iPadImg={selfPacedImg}
          {...course}
        />
      </div>

      {/*<!-- Curriculum -->*/}
      <div className='flex flex-col justify-center text-5xl'>
        <CurriculumLayoutB
          sectionBackgroundColor={'#F9F8F4'}
          buttonOutlineColor={'#000'}
          buttonHoverColor={`#fff`}
          {...course}
        />
      </div>

      {/*/!*BONUSES*!/*/}
      <div className='flex flex-col justify-center bg-cream-200'>
        <BonusesLayoutB
          spanColor={'#ea653d'}
          bonusSection={course.bonuses} />
      </div>

      {/* CLASS CARD */}
      <PatternClassCard
        image1={teelaWorking2}
        convert={true}
        {...course}
      />

      <div className='py-20 lg:py-40'>
        <LfmTestimonial direction='left' testimonial={testimonialFour} />
      </div>

      <div className='pb-20 lg:pb-40'>
        <LfmTestimonial direction='right' testimonial={testimonialFive} />
      </div>

      <div className=''>
        <LfmTestimonial direction='full' testimonial={testimonialSix} />
      </div>


      <div className='pt-20 pb-12 et-grid-basic lg:py-20 bg-grey-200'>
        <div className='flex items-center justify-center col-span-2 col-start-2 md:col-start-3 md:col-span-10'>
          <h2 className='mt-8 mb-12 text-5xl text-center font-sentinel__SemiBoldItal max-w-[600px]'>Shared in our private Facebook community:</h2>
        </div>
        {facebookImages.map((image, index) => {
          let css = undefined
          let containerCss = undefined
          if (index === 0) {
            css = `max-w-[332px] `
            containerCss = `lg:col-start-4 lg:col-span-6`
          }
          if (index === 1) {
            containerCss = `lg:row-start-3`
          }
          if (index === 2) {
            containerCss = `lg:col-start-4 lg:col-span-8`
          }
          if (index === 4) {
            containerCss = `lg:col-start-4 lg:col-span-8`
          }
          if (index === 5) {
            css = `max-w-[332px]`
          }
          return (
            <FacebookTestimonial
              key={index}
              cssModifier={css}
              containerCss={containerCss}
              image={image}
              even={!(index % 2)} />
          )
        })}
      </div>


      <Pattern30Day
        image={moneyBack}
      />

      {/* INSTRUCTOR */}
      <PatternAbout author={author1} iPad={aboutIpad} />

      {/* REQIREMENTS */}
      <div className='pt-12 md:pt-20'>
        <ReqsHalfPage reqs={reqs} featuredImage={reqsFeaturedImage} />
      </div>

      <div className='flex flex-col justify-center pb-12'>
        <FaqLayoutB
          subHead='FAQ'
          title='You may be wondering...'
          dangerouslySetAnswers={true}
          faqs={course.faqs}
          textColor={'#000'}
          textActivatedColor={'#000'}
        />
      </div>

      {/*/!*LETS DO THIS*!/*/}
      <PatternLetsDoThis {...course} />

      {/* CLASS CARD */}
      <div ref={priceRef} id={'price-section'} className='bg-cream-200'>
        <div id="checkout-card">
          <PatternClassCard
            convert={true}
            buttonText='Sign Me Up!'
            image1={teelaWorking}
            {...course}
          />
        </div>


        <div className='et-grid-basic'>

          <div className='flex flex-col col-span-2 col-start-2 gap-y-8 md:col-start-2 md:col-span-12 md:flex-row md:gap-x-8 lg:col-start-3 lg:col-span-10'>
            <div className='CARD bg-[#E9D0BA] rounded-2xl p-6 flex flex-col w-full  justify-between'>
              <h2 className='text-center'>{course.title}</h2>
              <h4 className={classNames(course.onSale ? '' : '', 'flex-1 text-4xl font-sentinel__SemiBoldItal mb-16 lg:text-center')}>One Time Purchase</h4>

              {course.onSale && <h5 className='text-xs font-semibold text-center uppercase'>Limited Time Offer</h5>}

              <div className='flex flex-row items-center my-4 mt-2 text-5xl gap-x-5 font-sentinel__SemiBoldItal lg:justify-center'>
                <div className={classNames('relative')}>
                  {course.onSale && <span className={classNames('z-2 absolute top-1/2 -rotate-12 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[130%] h-1 bg-[#A19183]')} />}
                  <span className={classNames('relative z-1', course.onSale ? 'text-[#A19183]' : '')}>
                    ${course.price}
                  </span>
                </div>
                {course.onSale && <div className='text-5xl text-rusted-900'>${course.salePrice}</div>}
              </div>

              <a href={course.onSale ? course.sellCard.saleLink : course.sellCard.link}
                className={classNames('btn-lg w-full mx-auto bg-rusted-900 !text-white border-rusted-900 flex-1 btn focus:outline-none md:flex-none')}>
                Let's do this!
              </a>


            </div>


            {/* MONTHLY PAYMENTS */}
            <div className='CARD bg-[#e8e1da] rounded-2xl p-6 flex flex-col w-full  justify-between'>
              <h2 className='text-center'>{course.title}</h2>
              <h4 className={classNames(course.onSale ? '' : '', 'flex-1 text-4xl font-sentinel__SemiBoldItal mb-16 lg:text-center')}>3 Monthly Payments </h4>

              {course.onSale && <h5 className='text-xs font-semibold text-center uppercase'>Limited Time Offer</h5>}

              <div className='flex flex-row items-center my-4 mt-2 text-5xl gap-x-5 font-sentinel__SemiBoldItal lg:justify-center'>
                <div className={classNames('relative flex flex-row')}>
                  {course.onSale && <span className={classNames('z-2 absolute top-1/2 -rotate-12 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[130%] h-1 bg-[#A19183]')} />}
                  <span className={classNames('relative z-1', course.onSale ? 'text-[#A19183]' : '')}>
                    ${course.paymentPlan.price}
                  </span>
                  <span className='flex flex-col mt-2 ml-2 text-sm'>
                    <span className='leading-none'>per</span>
                    <span className='leading-none'>month</span>
                  </span>
                </div>
                {course.onSale && <div className='text-5xl text-rusted-900'>${course.salePrice}</div>}
              </div>

              <a href={course.onSale ? course.sellCard.saleLink : course.sellCard.paymentPlanLink}
                className={classNames('btn-lg w-full mx-auto bg-[#3a322d] !text-white border-[#3a322d] flex-1 btn focus:outline-none md:flex-none')}>
                Let's do this!
              </a>

            </div>
          </div>
          {/* <h2 className='col-span-2 col-start-2 mb-4 text-2xl text-center font-sentinel__SemiBoldItal text-rusted-400 md:col-start-3 md:col-span-10 md:text-4xl md:mb-0'>
            <span className='block font-sans text-base text-rusted-900'>Regular price: $197</span>
            Intro price: ${course.salePrice}
          </h2> */}

          {/* <h2 className='col-span-2 col-start-2 mb-4 text-2xl text-center font-sentinel__SemiBoldItal text-rusted-400 md:col-start-3 md:col-span-10 md:text-4xl md:mb-0'>
            <span className='block font-sans text-base text-rusted-900'>Regular price: $197</span>
            Intro price: ${course.salePrice}
          </h2>

          <div className='col-span-2 col-start-2 text-center md:col-start-4 md:col-span-8 lg:col-start-5 lg:col-span-6'>
            <a href={course.onSale ? course.sellCard.saleLink : course.sellCard.link} className='flex flex-col text-xl text-center !text-white btn bg-rusted-900 border-rusted-900 py-3 md:py-5 lg:py-4 btn-shadow-3 font-medium'>
              Yes! I’m ready to create Procreate patterns!
            </a>
          </div>*/}
        </div>
      </div>


      {/* <PriceBar
        {...course}
        image={titleArt}
        buttonText='Enroll Now'
        price={course.onSale ? course.salePrice : course.price}
        scrollId='checkout-card'
        show={hasScrolled && !hasScrolledPrice}
        timer={course.motionMail}
        btnClasses='bg-white text-black font-bold border-white'
      /> */}

    </Layout>
  )
}
const BrushesText = () => {
  return (
    <>
      <p className='text-lg xl:text-xl'>
        When you enroll, you'll not only receive access to the full course's step-by-step videos, but a number of bonus assets, as well. Access to two full brush sets is included; one set of drawing brushes and one stamp set, so you'll have what you need to give your patterns character, structure and charm.
      </p>
    </>
  )
}
const ExtendedLicenseInfo = (props: { image: IGatsbyImageDataObject }) => {
  const { image } = props
  return (
    <div className='relative h-full mt-10 mb-10 md:mx-8 lg:h-auto'>
      <div className={'z-3 bg-rusted-400 q2 py-4 px-4 relative mx-auto md:text-center md:h-full md:flex md:items-center md:justify-center md:px-4 lg:px-8 lg:py-8 xl:py-16 xl:px-12 xxl:m-[0_auto_0 50px]'}>
        <p className={'text-2xl font-sentinel__SemiBoldItal text-white z-2 md:m-0 xxl:text-3xl'}>
          Extended License included, so you can sell unlimited artwork created with the brushes.
        </p>
      </div>
      <div className='absolute w-full h-full overflow-hidden top-5 bg-rusted-900 left-4 md:top-8 md:left-7 lg:left-10'>
        <GatsbyImage className='object-cover w-[600px] h-full absolute top-0 left-0' loading={IMAGELOADINGENUMS.LAZY} alt='Watercolor Florals painted in Procreate' image={image.gatsbyImageData} />
      </div>
    </div>

  )
}
const BrushesText1 = () => {
  return (
    <>
      <p className='mb-2 text-3xl font-bold'>
        Brush Set 1: Ink Lovers
      </p>
    </>
  )
}
const BrushesDesc1 = () => {
  return (
    <>
      <p className='mt-4 text-xl text-left md:mt-0'>
        The Ink Lovers brush set is filled with a variety of 12 subtle, scratchy and strong ink textured drawing brushes, perfect for bold details and easy-to-make floral and foliage elements.
      </p>
    </>
  )
}

const BrushesText2 = () => {
  return (
    <>
      <p className='mb-2 text-3xl font-bold'>
        Brush Set 2: Symmetry Block Stamps
      </p>
    </>
  )
}
const BrushesDesc2 = () => {
  return (
    <>
      <p className='mt-4 text-xl text-left md:mt-0'>
        This set of Symmetry Block Stamps includes 8 unique shape stamps contained within a square, perfect for creating the symmetry block pattern style.
      </p>
    </>
  )
}

const wylItems = [
  // 1
  {
    title: 'Composition Design',
    desc: 'Organize + create compelling floral arrangements with strategy',
    imageName: 'getting-started',
    imageOnly: false,
    bgTexture: 'wyl-t1',
    css: '',
    crop: false,
    bg: true,
    bgColor: '#35546D',
    textColor: '#fff',
  },
  // 2 
  {
    title: 'Simplification Process',
    desc: 'Reduce complex forms to their simplest shapes and textures',
    imageName: 'work-smarter',
    imageOnly: false,
    bgTexture: 'wyl-t2',
    bg: true,
    bgColor: '#FCAC98'
  },
  // 3
  {
    title: 'Choosing Color',
    desc: '3 methods for establishing and expanding unique floral palettes',
    imageName: 'strong-connections',
    imageOnly: false,
    bgTexture: 'wyl-t5',
    bg: true,
    bgColor: '#538E9C',
    textColor: '#fff',
  },
  // 4 
  {
    title: 'Basic Flat Floral Styles',
    desc: '6 style practice exercises for simpler florals',
    imageName: 'perfect-imports',
    imageOnly: false,
    bgTexture: 'wyl-t4',
    bg: true,
    bgColor: '#FFC8BA'
  },

  // 5
  {
    title: 'Flat Foliage Styles',
    desc: 'Several detailing ideas based on different leaf types',
    imageName: 'multilingual-support',
    imageOnly: false,
    bgTexture: 'wyl-t7',
    bg: true,
    bgColor: '#FCAC98',
  },

  // 6
  {
    title: 'Complex Flat Floral Styles',
    desc: '6 style practice exercises for complex, denser florals',
    imageName: 'finishing-touches',
    imageOnly: false,
    bgTexture: 'wyl-t6',
    bg: true,
    bgColor: '#538E9C',
    textColor: '#fff',
  },

  // 7
  {
    title: 'Freehand Compositions',
    desc: 'Learn how to adjust provided compositions or create your own from scratch',
    imageName: 'customizing-your-font',
    imageOnly: false,
    bgTexture: 'wyl-t8',
    bg: true,
    bgColor: '#35546D',
    textColor: '#fff',
  },

  // 8
  {
    title: 'Flat Depth',
    desc: 'Apply solid colored shadows and highlights strategically to create dimension',
    imageName: 'pua-encoding',
    imageOnly: false,
    bgTexture: 'wyl-t9',
    bg: true,
    bgColor: '#FFC8BA',
  },

  // 9
  {
    title: 'Horizontal + Vertical Arrangements',
    desc: 'Canvas specs and process for different composition formats',
    imageName: 'testing-process',
    imageOnly: false,
    bgTexture: 'wyl-t1',
    bg: true,
    bgColor: '#FCAC98',
  },

  // 10
  {
    title: 'Mini Bouquets',
    desc: 'How to create consistency within a family of mini bouquets',
    imageName: 'b-1',
    imageOnly: false,
    bgTexture: 'wyl-t2',
    bg: true,
    bgColor: '#538E9C',
    textColor: '#fff',
  },

  // 11
  {
    title: 'Seamless Patterns',
    desc: 'Add mini bouquets to a seamless pattern with transparent background',
    imageName: 'b-2',
    imageOnly: false,
    bgTexture: 'wyl-t3',
    bg: true,
    bgColor: '#FFC8BA',
  },

  // 12
  {
    title: 'Bonus: Application Tutorials',
    desc: 'Apply your artwork to 3 different common applications for future use',
    imageName: 'lettering-tips',
    imageOnly: false,
    bgTexture: 'wyl-t3',
    bg: true,
    bgColor: '#35546D',
    textColor: '#fff',
  },
  {
    title: '',
    desc: '',
    imageIndex: 0,
    imageOnly: true,
    bgTexture: '',
    css: 'image1',
    crop: true,
  },
  {
    title: '',
    desc: '',
    imageIndex: 1,
    imageOnly: true,
    bgTexture: '',
    css: 'image2',
    crop: false,
  },
]
const selfPaced = {
  title: '100% Self Paced',
  subtitle: 'Enrollment includes pre-recorded videos with lifetime access to all of them',
  desc: '<p style="margin-bottom: 12px;">Take the course at your own pace whenever it works with your schedule. There’s no pressure to hit a deadline or to fit everything in within a set amount of time.</p><p>And with lifetime access, you can refer back to it + watch it as many times as you’d like, too.</p>',
}
const reqs = [
  {
    title: '<h3>Procreate App <span>(v5.3.1 or newer)</span></h3>',
    desc: '<p>This course was filmed using v.5.3.1 of the Procreate app, so you’ll need to be on that version or newer to follow along.</p>',
    img: {
      src: 'procreate401/procreateIcon.png',
      alt: 'Procreate App',
    },
  },
  {
    title: '<h3>Apple iPad</h3>',
    desc: '<p>We utilize pressure variation within many of the brushes and designs, so you’ll need to have an iPad that supports pressure sensitivity. A list of iPads that offer this are <a href="https://every-tuesday.com/ipads" target="_blank" style="color: #ea653d;font-weight: bold;">available here</a>.</p>',
    img: {
      src: '/req-ipad-min.png',
      alt: 'Apple iPad',
    },
  },
  {
    title: '<h3>An iPad Stylus <span>(pressure sensitive)</span></h3>',
    desc: '<p>Since we’re utilizing pressure sensitivity settings, you’ll need a stylus that is compatible with your iPad. An Apple Pencil is recommended.</p>',
    img: {
      src: 'procreate701/req-3-min.png',
      alt: 'Apple Pencil',
    },
  },
  {
    title: '<h3>Familiarity with the Procreate interface</h3>',
    desc: '<p>A basic familiarity with Procreate is all you’ll need to get started! If you’re brand new to Procreate, I recommend taking my <a href="https://every-tuesday.com/5x" target="_blank" style="color: #ea653d;font-weight: bold;">free Procreate for Beginners course</a> first so you’ll be able to follow along more comfortably.</p>',
    img: {
      src: 'req-5x-min.png',
      alt: 'Procreate for Beginners',
    },
  },
]
const subHeadColorClass = 'text-peach-400'
const brushContent = {
  subheader: 'CUSTOM BRUSH SETS FOR PATTERN CREATION',
  title: '2 Full Brush Sets are Included with your Enrollment',
  text: 'The Ink Lovers brush set is filled with a variety of 12 subtle, scratchy and strong ink textured drawing brushes, perfect for bold details and easy-to-make floral elements.',
  quote: {
    cite: 'Extended License included, so you can sell unlimited artwork created with the brushes.',
    quoteColor: 'var(--ff-teal-600)',
  },
}
const mainColor = `#5f1212`
const highlight1 = `#B77DC3`
const customCheckmarkColors = [
  `#cc836f`,
  `#a79e8d`,
  `#6f7593`,
  `#b39299`,
  `#8faa7d`,
  `#758384`,
  `#edc370`,
  `#66514f`,
]
const modules = {
  projectIntroBeg: {
    headline: 'Create 5 pattern projects using 4 different pattern making methods',
    description:
      'Everything you need to create each project is included, along with full step-by-step video instruction',
  },
}
export default ProcreatePatterns

